import { configureOpenApiClients } from '../../api/configure';
import { historyGetDetails, historyGetTransactionHistory, historyGetTransactionHistoryOrder } from '../../api/v2';

export const useHistoryApi = (token: string) => {
  configureOpenApiClients();

  const getHistoryDetails = async (orderId: string): Promise<any> =>
    await historyGetDetails({
      path: { orderId },
      headers: { authorization: 'Bearer ' + token },
    });

  const getTransactionHistory = async (): Promise<any> =>
    await historyGetTransactionHistory({
      headers: { authorization: 'Bearer ' + token },
      query: { pageNbr: 1 },
    });

  const getTransactionById = async (orderId: string): Promise<any> =>
    await historyGetTransactionHistoryOrder({
      path: { orderId },
      headers: { authorization: 'Bearer ' + token },
    });

  return {
    getHistoryDetails,
    getTransactionHistory,
    getTransactionById,
  };
};
